export const basePropertyList = [
  'id',
  'name',
  'reviews',
  'rating',
  'location',
  'price',
  'gallery',
  'description',
];
